/**
 * SCM (Stock Check Message) 报文解析库存比对 API Service
 */

import apiClient from "./axios";

const BASE_PATH = "/v1/uld/scm/inbound";

export const parseScmInbound = (data) => {
    return apiClient.post(`${BASE_PATH}/parse`, data);
};

export const getScmPendingList = (params = {}) => {
    return apiClient.get(`${BASE_PATH}/pending`, { params });
};

export const getScmPendingById = (pendingId) => {
    return apiClient.get(`${BASE_PATH}/pending/${pendingId}`);
};

export const reparseScmPending = (pendingId) => {
    return apiClient.post(`${BASE_PATH}/pending/${pendingId}/reparse`);
};

export const confirmScmPending = (pendingId) => {
    return apiClient.post(`${BASE_PATH}/pending/${pendingId}/confirm`);
};

export const ignoreScmPending = (pendingId) => {
    return apiClient.post(`${BASE_PATH}/pending/${pendingId}/ignore`);
};

const scmApi = {
    parseScmInbound,
    getScmPendingList,
    getScmPendingById,
    reparseScmPending,
    confirmScmPending,
    ignoreScmPending,
};

export default scmApi;
